import { render, staticRenderFns } from "./uploadIcon.vue?vue&type=template&id=1cdf779d&"
import script from "./uploadIcon.vue?vue&type=script&lang=js&"
export * from "./uploadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports